// Source: app/scripts/controllers/bids.js
Auction.controller('BidsController', [
    '$scope',
    '$filter',
    '$routeParams',
    '$location',
    'toaster',
    'Auction',
    'Lot',
    'crudService',
    function ($scope, $filter, $routeParams, $location, toaster, Auction, Lot, crudService) {

        $scope.auctionId = $routeParams.auctionId;
        $scope.lotId = $routeParams.lotId;
        Auction.get({
            id: $scope.auctionId
        }, function (data) {
            $scope.auction = data;
            $scope.lot = Lot.get({
                id: $scope.lotId
            });

            Auction.getBids({
                auctionId: $scope.auctionId,
                lotId: $scope.lotId
            }, function (data) {
                $scope.bids = data;
            });
        });
    }]);
